/* eslint-disable camelcase */
class Grid {
  constructor ({ aggregation, column_definition, data }) {
    this.aggregation = aggregation
    this.data = data
    this.columnDefs = column_definition.map(colDef => {
      colDef.width = colDef.isColumn ? 38 : 220
      colDef.pinned = colDef.isColumn ? null : 'left'
      colDef.sortable = false
      colDef.cellStyle = params => params.value > 0
        ? { color: 'white', backgroundColor: 'red' }
        : { color: 'black', backgroundColor: 'white' }
      return colDef
    })
  }
}

export default Grid



// WEBPACK FOOTER //
// ./src/app/stock_break/models/Grid.js